/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { additionalQuestionDestroy } from '../../axios/additionalQuestionDestroy'
import type {
	AdditionalQuestionDestroyError,
	AdditionalQuestionDestroyPathParams,
	AdditionalQuestionDestroyResponse,
} from '../../types/AdditionalQuestionDestroy'

export const additionalQuestionDestroyMutationKey = () => [{ url: '/additional-questions/:question' }] as const

export type AdditionalQuestionDestroyMutationKey = ReturnType<typeof additionalQuestionDestroyMutationKey>

export type AdditionalQuestionDestroyVariables = {
	question: AdditionalQuestionDestroyPathParams['question']
}

/** @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::destroy */
export function useAdditionalQuestionDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		AdditionalQuestionDestroyResponse,
		AxiosError<AdditionalQuestionDestroyError>,
		AdditionalQuestionDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: additionalQuestionDestroyMutationKey(),
		mutationFn: ({ question }: AdditionalQuestionDestroyVariables) =>
			additionalQuestionDestroy(question, config).then(res => res.data),
		...options,
	})
}
